import { render, staticRenderFns } from "./classifyPopup.vue?vue&type=template&id=05b4f1e7&scoped=true&"
import script from "./classifyPopup.vue?vue&type=script&lang=js&"
export * from "./classifyPopup.vue?vue&type=script&lang=js&"
import style0 from "./classifyPopup.vue?vue&type=style&index=0&id=05b4f1e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b4f1e7",
  null
  
)

export default component.exports